import type { YardSource, YardStatus } from "@/lib/api";
import { YARD_SOURCES, YARD_STATUSES } from "@/lib/api";
import { compact } from "@/lib/qs";

export type YardsSearch = {
  q?: string;
  status?: YardStatus;
  source?: YardSource;
  interest?: string;
  view?: "board";
};

export type PartnersSearch = {
  q?: string;
};

function asString(value: unknown): string | undefined {
  return typeof value === "string" && value.trim() ? value.trim() : undefined;
}

export function validateYardsSearch(
  search: Record<string, unknown>,
): YardsSearch {
  const q = asString(search.q);
  const interest = asString(search.interest);
  const statusRaw = asString(search.status);
  const sourceRaw = asString(search.source);
  const status =
    statusRaw && (YARD_STATUSES as readonly string[]).includes(statusRaw)
      ? (statusRaw as YardStatus)
      : undefined;
  const source =
    sourceRaw && (YARD_SOURCES as readonly string[]).includes(sourceRaw)
      ? (sourceRaw as YardSource)
      : undefined;

  return compact({
    ...(q && { q }),
    ...(status && { status }),
    ...(source && { source }),
    ...(interest && { interest }),
    ...(search.view === "board" && { view: "board" as const }),
  });
}

export function validatePartnersSearch(
  search: Record<string, unknown>,
): PartnersSearch {
  const q = asString(search.q);
  return compact({
    ...(q && { q }),
  });
}
